module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image_1.bd54e414.webp";